module.exports = __webpack_public_path__ + "img/mail_outline_black_24dp.37885021.svg";